import { ProductId } from 'framework/products'
import { EcommerceService } from 'services'
import { ProductQueryParams } from '.'

class ProductService extends EcommerceService {
  async query(params: ProductQueryParams) {
    const { categories, page = 1, days = '', orderBy, sort, search, seller, tags = '', limit, zipcode } = params
    const order = orderBy || ''
    const sellerId = seller || ''
    const perPage = limit || 30
    const xxx = encodeURI(search || '')

    const self = this
    let url = `/products?nome=${xxx}&produtor_id=${sellerId}&categorias_slug=${categories}&tags_slug=${tags}&dias_entrega=${days}&page=${page}&orderby=${order}&sort=${
      sort || ''
    }&limit=${perPage}`

    if (zipcode) {
      url += `&cep_entrega=${zipcode}`
    }

    if (categories === 'experiencias') {
      url = `/products?nome=${xxx}&tipo_produto=experiencia&produtor_id=${sellerId}&tags_slug=${tags}&page=${page}&orderby=${order}&sort=${
        sort || ''
      }&limit=${perPage}`
    }

    const req = self.setUrl(url).get()

    return req
  }

  getById(productId: ProductId) {
    const self = this
    const url = `/products/${productId}`
    const req = self.setUrl(url).get()
    return req
  }

  getBestSellers() {
    const self = this
    const url = '/products/featured/mais_vendidos'
    const req = self.setUrl(url).get()
    return req
  }

  getMostRecent() {
    const self = this
    const url = '/products/featured/novos_por_aqui'
    const req = self.setUrl(url).get()
    return req
  }

  getFeatured() {
    const self = this
    const url = '/products/featured/produtos_em_destaque'
    const req = self.setUrl(url).get()
    return req
  }
}

export default ProductService
